// extracted by mini-css-extract-plugin
export default {"imagePlaceholder":"l1D965xMWfWYhMl3V89K","emptyVisual":"yFPjQWvdt_PqFVGY9mFw"};